import { Map } from 'immutable';

import * as t from './actionTypes';

const initialState = Map({
  practiceExams: [],
  questions: [],
  newQuestion: null,
  ratingExamId: null, // Rating exam (rate + rank + duty state + cycle)
  practiceExamInformationWaiting: false,
  rate: null,
  rank: null,
  dutyState: null,
  exam: null,
  selectedCycle: null,
  buildPracticeExamWaiting: false,
  removeQuestionWaiting: false,
  removeQuestionSuccess: false,
  activateExamWaiting: false,
  activateExamSuccess: false,
  buildAllExamsWaiting: false,
  buildAllExamsSuccess: false,
  buildAllExamsProgress: 0,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case t.SET_PRACTICE_EXAM_INFORMATION: {
      if (!action.data) {
        return state
          .set('practiceExams', [])
          .set('questions', [])
          .set('newQuestion', null)
          .set('ratingExamId', null)
          .set('exam', null);
      }

      return state
        .set('ratingExamId', action.data.exam ? action.data.exam.id : null)
        .set('practiceExams', action.data.practiceExams || [])
        .set('questions', action.data.questions || [])
        .set('selectedCycle', action.data.cycle ? action.data.cycle.id : null)
        .set('exam', action.data.selectedPracticeExam);
    }

    case t.SET_PRACTICE_EXAM_INFORMATION_WAITING:
      return state.set('practiceExamInformationWaiting', action.value);
    case t.SET_RATE:
      return state.set('rate', action.rate);
    case t.SET_RANK:
      return state.set('rank', action.rank);
    case t.SET_DUTY_STATE:
      return state.set('dutyState', action.dutyState);
    case t.SET_CYCLE:
      return state.set('selectedCycle', action.cycle);
    case t.SET_BUILD_PRACTICE_EXAM_WAITING:
      return state.set('buildPracticeExamWaiting', action.value);
    case t.SET_EXAM_AFTER_BUILD: {
      const practiceExams = state.get('practiceExams').map((practiceExam) =>
        practiceExam.id === action.exam.id
          ? {
              ...practiceExam,
              enabled: action.exam.enabled,
              amountQuestions:
                action.exam.amountQuestions ?? practiceExam.amountQuestions,
              examTimeInMillis:
                action.exam.examTimeInMillis ?? practiceExam.examTimeInMillis,
            }
          : practiceExam,
      );

      return state
        .set('practiceExams', practiceExams)
        .set('questions', action.questions || [])
        .set('newQuestion', action.newQuestionId ?? null);
    }

    case t.SET_REMOVE_QUESTION_SUCCESS:
      return state.set('removeQuestionSuccess', action.value);
    case t.SET_REMOVE_QUESTION_WAITING:
      return state.set('removeQuestionWaiting', action.value);
    case t.SET_ACTIVATE_EXAM_WAITING:
      return state.set('activateExamWaiting', action.value);
    case t.SET_ACTIVATE_EXAM_SUCCESS:
      return state.set('activateExamSuccess', action.value);
    case t.SET_BUILD_ALL_EXAMS_WAITING:
      return state.set('buildAllExamsWaiting', action.value);
    case t.SET_BUILD_ALL_EXAMS_SUCCESS:
      return state.set('buildAllExamsSuccess', action.value);
    case t.SET_BUILD_ALL_EXAMS_PROGRESS:
      return state.set('buildAllExamsProgress', action.value);
    default:
      return state;
  }
}
